import React, {FC} from "react";
import {AttachmentContentDto} from "../../domain/AttachmentContentDto";
import {applyEmailContentSafetySettings} from "../../util/SafetyTransformer";
import {LoadingIndicator} from "../common/LoadingIndicator";
import {Centre} from "../Centre";
import {ContentType} from "../../util/ContentTypes";
import {useAppSelector} from "../../hooks/ReduxHooks";
import styled from "@emotion/styled";
import {RawEmailView} from "./RawEmailView";
import {CalendarContentView} from "../calendar/CalendarContentView";
import {CalendarInviteParser} from "../../parsers/CalendarInviteParser";

export interface AttachmentContentViewProps {
    content: AttachmentContentDto;
}

const InnerEmailDiv = styled.div`
    margin: 5px;
    border: 1px solid #555;
`;

export const AttachmentContentView: FC<AttachmentContentViewProps> = ({content}) => {

    const darkTheme = useAppSelector(({system}) => system.theme === "dark");
    const whitelistedImages = useAppSelector(s => s.preferenceState.imageWhitelist);

    if (content.ContentType === "loading") {
        return <Centre><LoadingIndicator/></Centre>;
    }
    let html: string | undefined = undefined;
    if (content.ContentType === ContentType.EmailMessage || (content.ContentType === ContentType.PlainText && content.Content.startsWith("From: "))) {
        return (
            <InnerEmailDiv>
                <RawEmailView content={content.Content} embeddedView={true}/>
            </InnerEmailDiv>
        );
    } else if (content.ContentType === ContentType.HtmlText) {
        html = content.Content;
    } else if (content.ContentType.startsWith("text/calendar")) {
        const entry = new CalendarInviteParser().parse(content.Content);
        if (entry) {
            return (
                <CalendarContentView calendarEntry={entry} embeddedView={true}/>
            );
        }
    }

    if (!html) {
        return (
            <div className="email-content simple-content">
                <pre className="text-attachment">{content.Content}</pre>
            </div>
        );
    }

    if (html) {
        if (content.IsSafeHtml) {
            return <div dangerouslySetInnerHTML={({__html: html})}/>
        } else {
            const safetyResult = applyEmailContentSafetySettings(0, html, true, {
                applySafety: true,
                applyJunkSafety: false,
                darkTheme,
                mobile: false,
                containerWidth: 600,    // TODO: for non-mobile, find the width of the container
                whitelistedImages,
            });
            return <div className="email-content simple-content" dangerouslySetInnerHTML={({__html: safetyResult.safeContent})}/>
        }
    } else {
        return <div>Unsupported content type: {content.ContentType}</div>;
    }
}